import type { MenuItem } from '../auth/me';

/** Presentation only: daily work first (as in wygląd A), administration in its own group at the bottom. */
const WORK_ORDER = ['/podsumowanie', '/wydarzenia', '/moj-kalendarz', '/nowa-impreza', '/zadania', '/wyceny', '/katalog', '/szablony', '/reguly', '/dostepnosc', '/osoby', '/finanse', '/kontrahenci'];
export const ADMIN = new Set(['/uzytkownicy', '/ustawienia', '/powiadomienia/wysylka', '/tresc-podpowiedzi', '/uprawnienia']);
/**
 * The sections used every day, in the order they win a place on the phone's bottom bar (at most four; the rest
 * goes under "Więcej"). "Mój kalendarz" comes last: the owner keeps the four daily ones, crew without them gets it on the bar.
 */
const PHONE_TABS = ['/podsumowanie', '/wydarzenia', '/wyceny', '/katalog', '/dostepnosc', '/moj-kalendarz'];
const MAX_PHONE_TABS = 4;

function rank(item: MenuItem): number {
  const i = WORK_ORDER.indexOf(item.to);
  return i === -1 ? WORK_ORDER.length : i;
}

export function sidebarMenu(menu: MenuItem[]): { work: MenuItem[]; admin: MenuItem[] } {
  return { work: menu.filter((i) => !ADMIN.has(i.to)).sort((a, b) => rank(a) - rank(b)), admin: menu.filter((i) => ADMIN.has(i.to)) };
}

export function phoneMenu(menu: MenuItem[]): { tabs: MenuItem[]; more: MenuItem[] } {
  const { work, admin } = sidebarMenu(menu);
  const all = [...work, ...admin];
  const onBar = new Set(
    all
      .filter((i) => PHONE_TABS.includes(i.to))
      .sort((a, b) => PHONE_TABS.indexOf(a.to) - PHONE_TABS.indexOf(b.to))
      .slice(0, MAX_PHONE_TABS)
      .map((i) => i.to),
  );
  return { tabs: all.filter((i) => onBar.has(i.to)), more: all.filter((i) => !onBar.has(i.to)) };
}
